<template>
  <div class="steps-preview" :class="{ 'steps-preview--half-done': halfDone }">
    <SingleStep
      v-for="(step, index) in steps"
      :key="index"
      :is-active="index === activeStep"
      :is-done="index < activeStep"
      :step-number="index + 1"
      :title="step"
    />
  </div>
</template>

<script>
import SingleStep from './SingleStep';

export default {
  components: {
    SingleStep,
  },
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
  },
  computed: {
    halfDone() {
      return this.activeStep === 1;
    },
  },
};
</script>

<style lang="scss">
.steps-preview {
  position: relative;
  width: 40%;
  margin: auto;
  display: flex;
  justify-content: space-between;

  &::before {
    content: ' ';
    position: absolute;
    background: $lb-medium-gray;
    width: 100%;
    height: 2px;
    top: 15px;
  }

  &--half-done {
    &::before {
      background: $nephritis;
    }
  }
}
</style>
